import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getRemindersApi, getUserDashboardApi, getUserDashboardMatchesApi, getUserDashboardInterviewApi } from "../../API/API";

function* getDashboardSaga(action) {
  try {
    const response = yield call(() => getUserDashboardApi());
    yield put({
      type: types.GET_DASHBOARD_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_DASHBOARD_DETAILS_FAILURE, error });
    console.log(error);
  }
}

function* getDashboardMatchesSaga(action) {
  try {
    const response = yield call(() => getUserDashboardMatchesApi());
    yield put({
      type: types.GET_DASHBOARD_MATCHES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_DASHBOARD_DETAILS_FAILURE, error });
    console.log(error);
  }
}

function* getDashboardInterviewSaga(action) {
  try {
    const response = yield call(() => getUserDashboardInterviewApi());
    yield put({
      type: types.GET_DASHBOARD_INTERVIEWS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_DASHBOARD_DETAILS_FAILURE, error });
    console.log(error);
  }
}

function* getRemindersSaga(action) {
  try {
    const response = yield call(() => getRemindersApi());
    yield put({ type: types.GET_REMINDERS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_REMINDERS_FAILURE, error });
    console.log(error);
  }
}

export function* watchGetDashboardDetails() {
  yield takeEvery(types.GET_DASHBOARD_DETAILS_REQUESTED, getDashboardSaga);
}

export function* watchGetDashboardInterviewDetails() {
  yield takeEvery(
    types.GET_DASHBOARD_INTERVIEWS_REQUESTED,
    getDashboardInterviewSaga
  );
}

export function* watchGetDashboardMatchesDetails() {
  yield takeEvery(
    types.GET_DASHBOARD_MATCHES_REQUESTED,
    getDashboardMatchesSaga
  );
}
export function* watchGetReminders() {
  yield takeEvery(types.GET_REMINDERS_REQUESTED, getRemindersSaga);
}
